export default {
    getList: {
        getCloseWorkList: async function (params) {
            let option = {
                url: '/api/v1/worksheet/closure',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userCloseWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getAdvancedSearch: async function (params) {
            let option = {
                url: '/api/v1/worksheet/advancedsearch',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userCloseWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getSite: async function (params) {
            let option = {
                url: '/api/v1/worksheet/sites',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userCloseWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getUser: async function (params) {
            let option = {
                url: '/api/v1/worksheet/users',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userCloseWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
    }
}